var VERTICAL_MIN_WIDTH = 230;
var HORIZONTAL_MIN_WIDTH = 600;

var getPlayerMinSizes = function getPlayerMinSizes(ratio) {
  var isVertical = ratio <= 1;
  var minPlayerWidth = isVertical ? VERTICAL_MIN_WIDTH : HORIZONTAL_MIN_WIDTH;
  var minPlayerHeight = minPlayerWidth / ratio;
  return [minPlayerWidth, minPlayerHeight];
};

export default getPlayerMinSizes;